import * as React from 'react';
import { connect } from 'react-redux';
import { Button, Card, CardContent } from '@material-ui/core';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { useRouter } from 'next/router';

import * as types from '../../../actions/actionTypes';
import { isMobile } from '../../../lib/getDeviceSize';
import {
  updateProfile,
  sendRequestForLenderIntroduction,
} from '../../../actions/auth';

import style from '../../../styles/sass/pages/GetPreApproved.module.scss';

const styles = createStyles({
  buttonMediumGreen: {
    '&:hover': {
      backgroundColor: '#1a4d45',
    },
    alignSelf: 'center',
    backgroundColor: '#195A50',
    color: 'white',
    fontSize: 18,
    fontWeight: 'bold',
    height: 55,
    letterSpacing: 2,
    marginBottom: 50,
    marginTop: 35,
    textTransform: 'uppercase',
    width: 275,
    borderRadius: 30,
  },
  card: {
    alignItems: 'center',
    display: 'flex',
    height: isMobile() ? 326 : 295,
    justifyContent: 'center',
    margin: '0 auto',
    paddingLeft: isMobile() ? '10%' : 0,
    paddingRight: isMobile() ? '10%' : 0,
    width: isMobile() ? 350 : 640,
    zIndex: 1,
  },
  root: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
});

interface Props {
  classes: any;
  dispatch: any;
  requestedLenderIntro: boolean;
  token: string;
}

export function IntroduceBox(props: Props) {
  const { classes, token, dispatch, requestedLenderIntro } = props;
  const router = useRouter();
  const handleClick = () => {
    if (!token) {
      dispatch({
        postAuthPath: router.asPath,
        signupSubtext:
          'Sign up for an introduction to a lender as well as full access to millions of Torii listings.',
        type: types.OpenSignupDialog,
      });
    } else {
      dispatch(updateProfile({ needLenderIntroduction: true }, token));
      dispatch(sendRequestForLenderIntroduction(token));
    }
  };
  return (
    <Card className={classes.card}>
      <CardContent classes={{ root: classes.root }} style={{ padding: 0 }}>
        <h2 className={style.cardTitle}>Get Pre-Approved</h2>
        <p className={style.cardInfoText}>
          We work with the most experienced, highly-rated mortgage lenders
          around. Click below to request an introduction.
        </p>
        <Button
          className={classes.buttonMediumGreen}
          onClick={handleClick}
          variant="contained"
          type="submit"
          disabled={requestedLenderIntro}
        >
          {requestedLenderIntro ? 'REQUEST SENT' : 'INTRODUCE ME'}
        </Button>
      </CardContent>
    </Card>
  );
}

const mapStateToProps = (state: any) => ({
  requestedLenderIntro: state.auth.requestedLenderIntro,
  token: state.auth.token,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatch,
});

export default withStyles(styles)(
  connect(mapStateToProps, mapDispatchToProps)(IntroduceBox),
);
